/**
 * Created by Mohamed on 5/16/2016.
 */
(function(angular) {

    var events = {
        "post_updated": []
    };

    var trigger = function (eventName, param1, param2, param3, param4) {
        events[eventName].forEach(function (handler) {
            handler(param1, param2, param3, param4);
        });
    };

    /**
     * @namespace TSMediaViewerService
     *
     * @constructor
     */
    var TSMediaViewerService = function() {

        /**
         *
         * @name TSMediaViewerService
         */
        var self = this;
        var currentPost;

        /**
         * Event handler
         *
         * @name TSMediaViewerService#onPostUpdated
         * @param handler
         */
        self.onPostUpdated = function(handler) {
            events["post_updated"].push(handler);
        };

        /**
         * Show post media
         *
         * @name TSMediaViewerService#showPost
         * @param post
         * @param imageIndex
         * @type Function[{}]
         * @return Void
         */
        self.showPost = function(post, imageIndex) {
            currentPost = post;
            trigger("post_updated", currentPost, imageIndex);
            $(".ts-media-viewer").addClass("open");
            setTimeout(function() {
                $(".ts-media-viewer .ts-media-content").css("opacity", 1);
            }, 100);
        };

        /**
         * Close post
         *
         * @name TSMediaViewerService#close
         * @type Function[{}]
         * @return Void
         */
        self.close = function() {
            $(".ts-media-viewer .ts-media-content").css("opacity", 0);
            setTimeout(function() {
                $(".ts-media-viewer").removeClass("open");
                currentPost = null
                trigger("post_updated", currentPost);
            }, 300);
        };
    };

    angular
        .module('harriApp')
        .service('TSMediaViewerService', TSMediaViewerService);

})(angular);